import './result.css';

export interface IResult {
  /**
   * The id of the result field
   */
  id?: string,
  /**
   * The result shown to the user
   */
  result: string,
  /**
   * Class names
   */
  classNames?: string
}

/**
 * Primary UI component for tool results
 */
export const Result: React.FC<IResult> = ({ id, result, classNames }) => {
  return (
    <div id={id} className={classNames}>
      {result}
    </div>
  );
};

Result.defaultProps = {
  id: '',
  result: '',
  classNames: 'result-area'
};

export default Result;
